import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";

export default function NotFound() {
  return (
    <div className="min-h-screen grid place-items-center bg-[#FAFAFA] p-6">
      <div className="text-center max-w-md">
        <div className="text-9xl font-bold font-outfit text-[#6366F1]">404</div>
        <h1 className="text-2xl font-bold font-outfit mt-4">Page not found</h1>
        <p className="text-zinc-500 mt-2">The page you're looking for doesn't exist or has been moved.</p>
        <Link to="/"><Button className="mt-6 bg-[#6366F1] hover:bg-[#4F46E5]" data-testid="404-home">Back to home</Button></Link>
      </div>
    </div>
  );
}
